import React from 'react';

interface ProfileInvoicesListProps {
  children?: React.ReactNode;
  forwardedRef?: React.Ref<HTMLDivElement>;
}

export const ProfileInvoicesList: React.FC<ProfileInvoicesListProps> = ({
  forwardedRef,
  children
}) => {
  const refList = forwardedRef || null;

  return <div ref={refList}>{children}</div>;
};
